<template>
  <!-- <div class="waitnav"> -->
  <div class="cont">
    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster' }">工作通</el-breadcrumb-item>
        <el-breadcrumb-item>帮忙</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <!-- 上半部分-->
    <div class="topnav">
      <!-- 上左边 -->
      <div class="topnavleft">
        <!-- logo -->
        <div class="top">
          <div>
            <img
              src="@/assets/community/back.png"
              alt=""
              class="top-left-img"
              @click="back"
            />
          </div>
          <div>
            <img
              src="@/assets/work/wodebangzhu.png"
              alt=""
              class="top-midlle-img"
            />
          </div>
          <div class="top-midlle-span">帮忙详情</div>
        </div>
        <!-- logo下面的文字 -->
        <div class="topb">
          <div class="topbtext">
            <p style="font-size: 16px; margin-bottom: 5px">{{ info.title }}</p>
            <div class="atitle">
              <span class="toptitle" style="border-color: #4d71d9">
                <a style="color: #4d71d9">工资{{ info.wages }}</a>
              </span>
              <span class="toptitle" style="border-color: #ff6e31">
                <a style="color: #ff6e31">佣金{{ info.commission }}</a>
              </span>
              <span class="toptitle" style="border-color: #03ba48">
                <!-- 佣金方式， 1.按人 2.按件 3.总价-->

                <a style="color: #03ba48"
                  >佣金按{{
                    info.com_type == 1
                      ? "人"
                      : info.com_type == 2
                      ? "件"
                      : "总价"
                  }}</a
                >
              </span>
              <span class="toptitle" style="border-color: #03ba48">
                <!--佣金结算类型1.日结 2.周结 3.月结 4.完工结 5.入职结-->
                <a style="color: #03ba48"
                  >佣金{{
                    info.com_settle_type == 1
                      ? "日结"
                      : info.com_settle_type == 2
                      ? "周结"
                      : info.com_settle_type == 3
                      ? "月结"
                      : info.com_settle_type == 4
                      ? "完工结"
                      : "入职结"
                  }}</a
                >
              </span>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-bottom: 25px">
        <div style="height: 120px"></div>
        <div>
          <p>{{ info.js_time }}</p>
          <p style="font-size: 12px">截止时间</p>
        </div>
      </div>
    </div>
    <div class="spacee">
      <div class="aaaa"></div>
    </div>
    <!-- 下半部分 -->
    <div class="bottom">
      <!-- 项目进度 -->
      <div class="plan">
        <div class="progress">
          <span>项目进度</span>
          <br />
        </div>
        <div class="block">
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in info.hasMessage"
              :key="index"
              :color="activity.color"
              :timestamp="activity.created_at"
            >
              {{ activity.content }}
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
      <div class="space"></div>
      <!-- tab标签 -->
      <div class="tablabel">
        <!-- 招标信息 -->
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="招标信息" name="first">
            <div class="information">
              <p>项目标题</p>
              <span>{{ info.title }}</span>
            </div>
            <div class="information">
              <p>项目简介</p>
              <span>{{ info.description }}</span>
            </div>
            <div class="information">
              <div>
                <p>员工工资</p>

                <span>{{ info.wages }}元</span>
              </div>
              <div>
                <p>佣金</p>
                <span>{{ info.commission }}元</span>
              </div>
              <div>
                <p>佣金结算方式</p>
                <span
                  >佣金{{
                    info.com_settle_type == 1
                      ? "日结"
                      : info.com_settle_type == 2
                      ? "周结"
                      : info.com_settle_type == 3
                      ? "月结"
                      : info.com_settle_type == 4
                      ? "完工结"
                      : "入职结"
                  }}</span
                >
              </div>
            </div>
            <div class="information">
              <div>
                <p>起始时间</p>
                <span>{{ info.start_at  }}</span>
              </div>
              <div>
                <p>结束时间</p>
                <span>{{ info.end_at  }}</span>
              </div>
            </div>
            <div class="information">
              <p>招标描述</p>
              <span>{{ info.description }}</span>
            </div>
          </el-tab-pane>
          <!-- 投标信息 -->
          <el-tab-pane label="投标信息" name="second">
            <div style="width: 650px">
              <el-table :data="info.hasBid" style="600px">
                <el-table-column prop="alias_name" label="投标人" width="100px">
                </el-table-column>
                <el-table-column prop="remarks" label="说明" width="">
                </el-table-column>
                <el-table-column prop="bid_status" label="是否中标" width="">
                  <!--0待选标 1已中标 2已淘汰
                  -->
                  <template slot-scope="{row}">
                    <span v-if="row.bid_status == 0" style="color: #FF9004;">待选标</span>
                    <span v-if="row.bid_status == 1" style="color: #03ba48;">已中标</span>
                    <span v-if="row.bid_status == 2" style="color: #FF4E4E;">已淘汰</span>
                  </template>  
                </el-table-column>

                <el-table-column label="操作">
                  <template slot-scope="{row}">
                    <el-button @click="handleDetail(row)" type="text" size="small">
                      详情
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="bttomb"></div>
    <div class="publish">
      <button class="Unpublish" @click="cancel">取消发布</button>
    </div>

    <biddetail-dialog ref="detailDialogRef"></biddetail-dialog>
  </div>
  <!-- </div> -->
</template>

<script>
import { webCrowdInfo,webCrowdUpdate } from "@/api/director/package/index";
import biddetailDialog from "./dialog/biddetail-dialog.vue";

export default {
  components: {
    biddetailDialog,
  },
  data() {
    return {
      crowd_id: "",
      info: {},

      activeName: "first",
      questionForm: {},
      dialogFormVisible: false,
    };
  },

  mounted() {
    if (this.$route.query.crowd_id != "") {
      this.crowd_id = this.$route.query.crowd_id;
      this.initData();
      // 获取接口
    }
  },

  methods: {
    // 获取列表的方法
    initData() {
      webCrowdInfo({ crowd_id: this.crowd_id }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.info = res.data;
        } else {
          this.$message.error(res.msg ? res.msg : "请求错误");
        }
      });
    },

    handleDetail(item) {
      this.$refs.detailDialogRef.init(item);
    },

    cancel(){
      var that=this;
        this.$confirm('确定取消发布?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          webCrowdUpdate({crowd_id:this.crowd_id,status:2}).then((response) => {
              console.log(response);
              if(response.code==200){
                  that.initData();
              }else{
                  that.$message.error(response.msg?response.msg:"操作失败");
              }
            });
          
        }).catch(() => {
        
        });

    },

    formatDateTime(value) {
      // 时间戳转换日期格式方法
      if (value == null) {
        return "";
      } else {
        const date = new Date(value);
        const y = date.getFullYear(); // 年
        let MM = date.getMonth() + 1; // 月
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate(); // 日
        d = d < 10 ? "0" + d : d;
        let h = date.getHours(); // 时
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes(); // 分
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds(); // 秒
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      }
    },

    back() {
      this.$router.go(-1);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>

<style lang="scss" scoped>
.aaaa {
  position: relative;
  // padding: 2px;
  background: white;
  width: 623px;
  height: 1px;
  border-radius: 25px;
}
.aaaa::after {
  position: absolute;
  border-radius: 5px;
  content: "";
}
.publish {
  background-color: #ffffff;
  width: "100%";
  // margin: -10px -30px 0px -30px;
  border-radius: 5px;
}
.Unpublish {
  color: #f8f8f8;
  width: 90px;
  height: 35px;
  border-radius: 8px;
  background-color: #4d71d9;
  border-style: none;
  margin-top: 30px;
  margin-left: 800px;
}
.bttomb {
  // width: 980px;
  height: 20px;
  margin-left: -20px;
  margin-right: -20px;
  background-color: #f8f8f8;
  z-index: 1;
}
.block {
  margin-top: 21px;
}
.spacee {
  z-index: 2;
  height: 20px;
  margin-left: -20px;
  margin-right: -20px;
  background-color: #f8f8f8;
}
.atitle {
  width: 250px;
  display: flex;
}

.proplan {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: 15px;
  margin-top: 15px;
}

.circle {
  width: 10px;
  height: 10px;
  border-radius: 25px;
  background-color: #4d71d9;
  margin-top: 5px;
  margin-right: 5px;
}

.plan {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  // margin: -5px -20px -5px -30px;
  border-radius: 5px;
  background-color: #ffffff;
  padding: 5px;
  z-index: 2;
  margin-top: 23px;
}

.toptitle {
  margin: 0 auto;
  font-size: 10px;
  padding: 5px;
  border-style: solid;
  border-radius: 2px;
}

.time {
  color: #acacac;
  margin-left: 15px;
}

.space {
  width: 10px;
  height: 663px;
  // margin: -2px 10px 0px 10px;
  background-color: #f8f8f8;
  z-index: 1;
}
.waitnav {
  margin: 10px 10px;
  background-color: #f8f8f8;
}

.cont {
  width: 100%;

  .topnav {
    // padding: 15px;
    // margin: 0px -30px -10px -30px;
    // background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    z-index: 3;
    border-radius: 25px;
    .topnavleft {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .topb {
        display: flex;
        justify-content: space-between;
        margin-left: 25px;
        min-width: 255px;
      }

      .topbtext {
        margin-bottom: 10px;

        p {
          font-size: 13px;
          color: #000000;
          font-weight: 500;
        }

        span {
          font-size: 11px;
        }
      }
    }

    .topnavright-img {
      width: 72px;
      height: 72px;
      margin: 41px 43px 39px 0px;
    }
  }

  .bottom {
    background-color: white;
    display: flex;
    flex-direction: row;
    // margin-right: -30px;
    border-radius: 25px;
    z-index: -1;
  }
}

.top {
  // width: 950px;
  display: flex;
}

.top-left-img {
  margin-top: 8px;
  width: 25px;
  height: 25px;
}

.top-midlle-img {
  width: 40px;
  height: 40px;
}

.top-midlle-span {
  margin-left: 20px;
  margin-top: 8px;
  height: 16px;
  font-size: 16px;
  color: #181818;
  font-weight: bold;
}

.top-right {
  margin-top: 2px;
  margin-left: 740px;
}

.tablabel {
  z-index: 2;
  margin-left: -12px;
  // margin-top: -5px;
  margin-bottom: -5px;
  // background-color: #ffffff;
  // border-radius: 5px;
  padding-left: 30px;
  margin-top: 25px;
  // width: 800px;
  p {
    font-size: 11px;
    color: #acacac;
    margin-bottom: 12px;
  }

  span {
    font-size: 11px;
    font-weight: bold;
    color: #000000;
  }

  .information {
    margin-top: 26px;
  }

  .information:nth-child(1) {
    margin-top: 10px;
  }

  .information:nth-child(3) {
    display: flex;
    // flex-direction: column;

    div {
      width: 78px;
      margin-right: 129px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .information:nth-child(4) {
    display: flex;

    div {
      width: 78px;
      margin-right: 129px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .requirements {
    margin-top: 26px;

    div {
      width: 81px;
    }
  }

  .requirements:nth-child(1) {
    margin-top: 10px;
    display: flex;

    div {
      margin-right: 260px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .requirements:nth-child(2) {
    display: flex;

    div {
      margin-right: 260px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .requirements:nth-child(3) {
    display: flex;

    div {
      margin-right: 260px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .requirements:nth-child(4) {
    display: flex;

    p {
      height: 11px;
    }

    span {
      color: #4d71d9;
    }

    div {
      margin-right: 42px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }
}

::v-deep .el-tabs__nav-wrap::after {
  width: auto;
}

::v-deep .el-tabs__item {
  color: #acacac;
}

::v-deep .el-tabs__item.is-active {
  color: #4d71d9;
}

::v-deep .el-tabs__active-bar {
  height: 3px;
}
</style>
